import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=68919d08&scoped=true&"
import script from "./CustomerCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68919d08",
  null
  
)

export default component.exports